module.exports = "/images/fullsize-2.svg?040323b8e9dfe4ca652c9ac552f76835";